import { useCallback } from "react";
import { useMutation } from "react-query";

import type { OtpChannel } from "@jti/fe-common";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { CasProfileApi } from "../../../services";

import type { UseSendOTCReturnType } from "./types";

export const useSendOTC = (): UseSendOTCReturnType => {
  const callSendOTC = useMutation(
    MUTATION_KEYS.sendOTC,
    ({ phone, otpChannel, template }: { phone: string; otpChannel: OtpChannel; template?: string }) =>
      CasProfileApi.init().sendOTC(phone, otpChannel, template)
  );

  const sendOTC = useCallback(
    async (phone: string, otpChannel: OtpChannel, otpTemplateName?: string) =>
      await callSendOTC.mutateAsync({ phone, otpChannel, template: otpTemplateName }),
    [callSendOTC]
  );

  return { sendOTC };
};
